import axios from 'axios';
import qs from 'qs';
import { getUserToken } from '../utils/userToken';

const CancelToken = axios.CancelToken
let sources = []
let removeSource = (config) => {
    for (let source in sources) {

        if (sources[source].umet === config.url + '&' + config.method) {
            sources[source].cancel("Request canceled")
            sources.splice(source, 1)
        }
    }
}


axios.interceptors.request.use(config => {
    let url = config.url.split('/');
    let method = url[url.length - 1]
    if (method !== 'g_single_translation' && method !== 's_one_third_party_app_trans' && method !== 's_lan_auto_sync_trans') {
        removeSource(config)
        config.cancelToken = new CancelToken((c) => {

            sources.push({ umet: config.url + '&' + config.method, cancel: c })
        })
    }
    return config
}, error => {
    return Promise.reject(error)
})


axios.interceptors.response.use(response => {

    removeSource(response.config)
    return response
}, error => {
    return Promise.reject(error)
})

export default function ajax(url, data = {}, type = 'GET', headers = "false", options = {}) {
    return new Promise((resolve, reject) => {
        let promise;
        const requestData = { ...data };
        if (url.includes('/api/a/') && !url.includes('/api/a/b/')) {
            const userToken = getUserToken();
            if (userToken) {
                requestData.user_token = userToken;
            }
        }

        if (type === 'GET') {
            promise = axios.get(url, {
                params: requestData
            })
        }

        else if (type === 'POST') {
            if (headers === 'false') {
                promise = axios.post(url, qs.stringify(requestData))
            } else {
                promise = axios.post(url, requestData, { responseType: options.responseType })
            }
        }

        promise.then((response, reject) => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}
